import * as React from 'react';
import { Link } from 'react-router-dom';
import styles from './tile-link.scss';

interface SearchLinkComponentProps {
  url: string;
  title: string;
}

export const TileLink: React.FC<React.PropsWithChildren<SearchLinkComponentProps>> = ({
  url, title
}) => (
    <Link to={url} className={styles.tileTitle}>
      <span>{title}</span>
    </Link>
  );
